import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_broken",
  "use": "micro_broken-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_broken\"><path d=\"M5 0a5 5 0 0 1 5 5v5L7.5 8l-2.499 2L2.5 8 0 10V5a5 5 0 0 1 5-5ZM3 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol